import {useState, useMemo, useEffect, useContext} from "react";
import {useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import ConditionalRender from "components/ConditionalRender";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "../navs";
import AuthContext from "context/AuthContext";
import TabBasic from "./TabBasic";
import TabAdvanced from "./TabAdvanced";
import TabSender from "./TabSender";
import translations from "./translations";
import useCustomTranslation from "core/customTranslation";

const ViewPGA = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _TC} = useCustomTranslation(translations);
    const title = "PGA460";
    document.title = title;
    const bread = useMemo(
        () => [
            {
                name: _Tr("labels.advanced"),
                url: "/advanced/",
                current: false,
            },
            {name: title, current: true},
        ],
        [_Tr, title],
    );

    const {panel} = useContext(AuthContext);
    const MODELS_ACCEPTED = ["MQ2-4G"];
    const [keyTab, setKeyTab] = useState("basic");
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const tabParam = searchParams.get("t");
        if (tabParam === "a") {
            setKeyTab("advanced");
        } else if (tabParam === "b") {
            setKeyTab("basic");
        } else if (tabParam === "s") {
            setKeyTab("sender");
        }
    }, [searchParams]);

    const onSelectTab = (k) => {
        setKeyTab(k);
        const tabMap = {
            basic: "b",
            advanced: "a",
            sender: "s",
        };
        setSearchParams({t: tabMap[k]});
    };

    const hasAccess = () => {
        if (!panel?.sensors || panel.sensors.length === 0) {
            return false;
        }
        return panel.sensors.some((userSensor) => MODELS_ACCEPTED.includes(userSensor));
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <ConditionalRender
                condition={hasAccess}
                fallback={
                    <div className="alert alert-secondary text-center">
                        {_TC("noData")}
                    </div>
                }>
                <Tabs
                    activeKey={keyTab}
                    id="mqtt-tabs"
                    onSelect={onSelectTab}
                    className="mb-3 mt-1 nav-tabs-fs-15">
                    <Tab eventKey="basic" title={_TC("basic")} className="nuevo">
                        <TabBasic _TC={_TC} />
                    </Tab>
                    <Tab eventKey="advanced" title={_TC("advanced")}>
                        <TabAdvanced _TC={_TC} />
                    </Tab>
                    <Tab eventKey="sender" title={_TC("sender")}>
                        <TabSender _TC={_TC} />
                    </Tab>
                </Tabs>
            </ConditionalRender>
        </>
    );
};
export default ViewPGA;
